import React, { memo } from 'react'
import { Button } from '@mui/material'

const SubmitButton = ({
  label,
  fullWidth = false,
  type = 'submit',
  size = 'large',
  ...restProps
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      color='inherit'
      type={type}
      variant='contained'
      loadingPosition='end'
      size={size}
      {...restProps}
    >
      {label}
    </Button>
  )
}

export default memo(SubmitButton)
